import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cave-hero-salon/artifacts/mz0y0jq3_WhatsApp_Image_2026-02-20_at_5.57.50_PM-removebg-preview.png";

function CinematicIntro({ onComplete }) {
  const [phase, setPhase] = React.useState("black");
  // Phases: black -> appear -> fadeout -> done

  React.useEffect(() => {
    if (sessionStorage.getItem("cave_intro_shown")) {
      onComplete();
      return;
    }

    // Phase 1: Black screen 300ms
    const t1 = setTimeout(() => setPhase("appear"), 300);

    // Phase 2: Logo holds for 1.4s then fades out
    const t2 = setTimeout(() => setPhase("fadeout"), 1700);

    // Phase 3: Complete
    const t3 = setTimeout(() => {
      sessionStorage.setItem("cave_intro_shown", "true");
      onComplete();
    }, 2800);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [onComplete]);

  if (sessionStorage.getItem("cave_intro_shown") && phase === "black") {
    return null;
  }

  return (
    <div
      data-testid="cinematic-intro"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backgroundColor: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: phase === "fadeout" ? 0 : 1,
        transition: "opacity 1s cubic-bezier(0.22, 1, 0.36, 1)",
        pointerEvents: phase === "fadeout" ? "none" : "auto",
      }}
    >
      <img
        src={LOGO_URL}
        alt="CAVE"
        style={{
          width: "160px",
          height: "auto",
          objectFit: "contain",
          opacity: phase === "appear" || phase === "fadeout" ? 1 : 0,
          transition: "opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1)",
        }}
      />
    </div>
  );
}

export default CinematicIntro;
